import { TitleH3 } from "components/generic";
import styled from "styled-components/macro";

export const TenantsCard = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: max-content 1fr;
  & > img {
    border-radius: 50%;
    height: 100px;
    width: 100px;
  }
  & > div:last-child {
    grid-area: 2 / 2 / auto / auto;
    display: inline-grid;
    gap: 24px;
    grid-template-columns: max-content max-content;
    @media ${(props) => props.theme.media.phone} {
      grid-area: auto;
      grid-template-columns: 1fr;
    }
  }
  & > div {
    margin-left: 40px;
  }
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
    & > div {
      margin: 24px 0 0 0;
    }
  }
`;

export const RemoveTenant = styled(TitleH3)`
  color: ${(props) => props.theme.colors.thirdly};
  cursor: pointer;
`;


export const WrapperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  & .aboutStudent {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & .header {
    color: ${(props) => props.theme.colors.text};
    font-size: 18px;
    font-weight: 600;
    line-height: 133%;
  }
  .main {
    margin-top: 1rem;
    display: flex;
    img {
      margin-right: 1.5rem;
      width: 200px;
      height: 200px;
      object-fit: cover;
    }

    @media ${(props) => props.theme.media.phone} {
      flex-wrap: wrap;
      img {
        width: 100%;
        margin-bottom: 1rem;
      }
    }
  }
  hr {
    margin-top: 1rem;
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid ${(props) => props.theme.colors.border};
  }
  .footer {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    .dates {
      display: flex;
      align-items: center;
      & > svg {
        margin-right: 8px;
      }
    }
    .buttons {
      display: flex;
      button {
        margin-left: 10px;
      }
    }
    @media ${(props) => props.theme.media.phone} {
      flex-direction: column;
      width: 100%;
      .buttons {
        flex-direction: column;
        button {
          margin-top: 1rem;
          width: 100%;
          margin-left: 0;
        }
      }
    }
  }
`;


export const MainWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  justify-items: center;
  transition: 0.5s;
  & > div > div > img {
    height: 100px;
    width: 100px;
    margin-right: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
  & hr {
    margin: 1em 0;
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid ${(props) => props.theme.colors.border};
  }
  & .buttonGroup {
    @media ${(props) => props.theme.media.phone} {
      width: 100%;
      & > button:first-child {
        margin-bottom: 8px;
      }
      & button {
        width: 100%;
      }
    }
  }
`;
